import Label from "../../../../../components/label/Label";

const IndustryExperience = ({ fromTalent, client, industryExperiences }) => {
    return (
        <>
            {industryExperiences?.length > 0 && (
                <div
                    className={
                        fromTalent && !client
                            ? "freelancerModalComponentWrap ml-0"
                            : "freelancerModalComponentWrap"
                    }
                >
                    <Label
                        label="Industry Experience"
                        className="font18Black boldFont sectionTitleWrapper"
                    />
                    <div className="d-flex mt-2 flex-wrap">
                        {industryExperiences?.map((data, index) => {
                            return (
                                <div
                                    key={index}
                                    className="rolesandratesInactiveChipFreelancer mr-2 mb-2"
                                >
                                    {data}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </>
    );
};

export default IndustryExperience;
